<template>
  <div>
    <SjCard style="width: 100%;height: 240px">
      <SjBlank />
    </SjCard>
    自定义文本
    <SjCard style="width: 100%;height: 240px">
      <SjBlank text="不符合要求" />
    </SjCard>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="less"></style>
